var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 181,
    viewBox: "0 0 490 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6436 139.497H30.2443C32.0022 116.88 50.7529 99.0346 73.6502 99.0346C87.8484 99.0346 100.424 105.881 108.357 116.483C114.307 110.299 122.645 106.411 131.885 106.411C132.156 106.411 132.426 106.411 132.697 106.411C137.024 80.8356 159.065 61.3113 185.703 61.3113C200.352 61.3113 213.649 67.2305 223.34 76.8159C244.93 31.3624 290.995 0 344.272 0C418.328 0 478.321 60.5162 478.321 135.168C478.321 136.581 478.276 137.995 478.231 139.408H501.669C512.983 139.408 522.268 148.773 522.268 160.169C522.268 171.566 512.983 180.93 501.669 180.93H20.5985C9.28506 180.93 0 171.566 0 160.169C0 148.773 9.28506 139.408 20.5985 139.408L20.6436 139.497Z",
    fill: "url(#paint0_linear_728_3008)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6436 139.497H30.2443C32.0022 116.88 50.7529 99.0346 73.6502 99.0346C87.8484 99.0346 100.424 105.881 108.357 116.483C114.307 110.299 122.645 106.411 131.885 106.411C132.156 106.411 132.426 106.411 132.697 106.411C137.024 80.8356 159.065 61.3113 185.703 61.3113C200.352 61.3113 213.649 67.2305 223.34 76.8159C244.93 31.3624 290.995 0 344.272 0C418.328 0 478.321 60.5162 478.321 135.168C478.321 136.581 478.276 137.995 478.231 139.408H501.669C512.983 139.408 522.268 148.773 522.268 160.169C522.268 171.566 512.983 180.93 501.669 180.93H20.5985C9.28506 180.93 0 171.566 0 160.169C0 148.773 9.28506 139.408 20.5985 139.408L20.6436 139.497Z",
    fill: "url(#paint1_linear_728_3008)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_728_3008",
    x1: 261.653,
    y1: -0.0000402084,
    x2: 261.653,
    y2: 521.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE90D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDCB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_728_3008",
    x1: 261.134,
    y1: 0,
    x2: 261.134,
    y2: 180.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEF8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEF8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRCloud);
export default __webpack_public_path__ + "static/media/r-cloud.df1dfbb59c9d965f02b33dd6867a1b44.svg";
export { ForwardRef as ReactComponent };